import { render, staticRenderFns } from "./TemplateCambios.vue?vue&type=template&id=18f50f11&scoped=true&"
var script = {}
import style0 from "./TemplateCambios.vue?vue&type=style&index=0&id=18f50f11&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f50f11",
  null
  
)

export default component.exports